import React from "react";

const AppSimpleTable = ({
  columns = [],
  data = []
}) => {
  const getColumnMinWidth = (col) => {
    if (!col?.width) return 180;
    if (typeof col.width === "number") return col.width;
    if (typeof col.width === "string" && col.width.endsWith("px")) {
      const parsedWidth = parseInt(col.width, 10);
      return Number.isNaN(parsedWidth) ? 180 : parsedWidth;
    }
    return 180;
  };

  const getColumnWidth = (col) => {
    if (col.width) {
      return { width: col.width, flexShrink: 0 };
    }
    // minWidth: 0 lets the column actually shrink below its content's
    // natural size instead of stretching the row (and pushing fixed-width
    // columns like a toggle out of view) when content is long.
    return { flex: 1, minWidth: 0 };
  };

  const tableMinWidth = `${Math.max(
    columns.reduce((acc, col) => acc + getColumnMinWidth(col), 0),
    640
  )}px`;

  return (
    <div className="w-full overflow-x-auto">
      <div
        className="bg-white rounded-2xl border border-gray-200 overflow-hidden p-2"
        style={{ minWidth: tableMinWidth }}
      >
        {/* Header */}
        <div className="bg-white rounded-t-xl mb-2">
          <div className="flex">
            {columns.map((col) => (
              <div
                key={`column-${col.key}`}
                className="text-left text-sm font-semibold text-gray-700 px-4 py-3 whitespace-nowrap"
                style={getColumnWidth(col)}
              >
                {col.title}
              </div>
            ))}
          </div>
        </div>

        {/* Rows */}
        <div className="space-y-2">
          {data.map((row, rowIndex) => (
            <div
              key={`row-${row._id || row.id || rowIndex}`}
              className="bg-primary-light border border-secondary-light rounded-xl hover:shadow-sm transition-shadow"
            >
              <div className="flex">
                {columns.map((col) => (
                  <div
                    key={`row-${row._id || row.id || rowIndex}-column-${col.key}`}
                    className="text-sm text-gray-700 px-4 py-3 flex items-center truncate"
                    style={getColumnWidth(col)}
                  >
                    {col.render
                      ? col.render(row[col.dataIndex], row, rowIndex)
                      : row[col.dataIndex]}
                  </div>
                ))}
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default AppSimpleTable;